import React, { useState, useRef, useEffect } from 'react'
import { Dropdown, Input, Menu } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

export const SearchableDropdown = ({
  options = [],
  onSelect,
  placeholder = 'Search band...',
  emptyText = 'No matching bands',
  maxHeight = 220,
  trigger = ['click'],
  placement = 'bottomLeft',
  children
}) => {
  const [visible, setVisible] = useState(false)
  const [searchText, setSearchText] = useState('')
  const inputRef = useRef(null)

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        inputRef.current?.focus()
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [visible])

  const handleVisibleChange = (flag) => {
    setVisible(flag)
    if (!flag) {
      setSearchText('')
    }
  }

  const handleSelect = (key) => {
    if (onSelect) {
      onSelect(key)
    }
    setVisible(false)
    setSearchText('')
  }

  const filteredOptions = options.filter(option =>
    option ? option.toString().toLowerCase().includes(searchText.trim().toLowerCase()) : false
  )

  const handlePressEnter = () => {
    if (filteredOptions.length === 1) {
      handleSelect(filteredOptions[0])
    } else if (filteredOptions.length > 1) {
      const exactMatch = filteredOptions.find(
        opt => opt && opt.toString().toLowerCase() === searchText.trim().toLowerCase()
      )
      if (exactMatch) {
        handleSelect(exactMatch)
      }
    }
  }

  const menu = (
    <div
      style={{
        background: '#fff',
        borderRadius: 4,
        boxShadow: '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
        minWidth: 160,
        overflow: 'hidden'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div style={{ padding: '8px 8px 4px 8px' }}>
        <Input
          ref={inputRef}
          size='small'
          prefix={<SearchOutlined className='text-gray-400' />}
          placeholder={placeholder}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              setVisible(false)
              setSearchText('')
            }
            e.stopPropagation()
          }}
          onPressEnter={handlePressEnter}
          allowClear
        />
      </div>
      <div style={{ maxHeight, overflowY: 'auto' }}>
        {filteredOptions.length > 0 ? (
          <Menu
            selectedKeys={[]}
            onClick={({ key }) => handleSelect(key)}
            style={{ borderRight: 'none', boxShadow: 'none' }}
          >
            {filteredOptions.map(option => (
              <Menu.Item key={option}>{option}</Menu.Item>
            ))}
          </Menu>
        ) : (
          <div style={{ padding: '12px 8px', textAlign: 'center', color: '#8c8c8c', fontSize: '12px' }}>
            {emptyText}
          </div>
        )}
      </div>
    </div>
  )

  return (
    <Dropdown
      overlay={menu}
      trigger={trigger}
      visible={visible}
      onVisibleChange={handleVisibleChange}
      placement={placement}
    >
      {children}
    </Dropdown>
  )
}
